export const clientConfig = {
    'mapboxToken': process.env.REACT_APP_MAPBOX,
    'analyticsKey': process.env.REACT_APP_ANALYTICS_KEY,
    'tagManagerKey': process.env.REACT_APP_TAG_KEY,
    'hotjarKey': process.env.REACT_APP_HOTJAR_KEY,
    'hotjarSv': process.env.REACT_APP_HOTJAR_SV,
    'pixelKey': process.env.REACT_APP_PIXEL_KEY,
};